const DecimalJS = require('decimal.js');

module.exports = {
  add(v1, v2) {
    const value = DecimalJS.add(v1, v2).toFixed(2);
    return Number(value);
  },
  sub(v1, v2) {
    const value = DecimalJS.sub(v1, v2).toFixed(2);
    return Number(value);
  },
  mul(v1, v2) {
    const value = DecimalJS.mul(v1, v2).toFixed(2);
    return Number(value);
  },
  div(v1, v2) {
    const value = DecimalJS.div(v1, v2).toFixed(2);
    return Number(value);
  },
  toDecimal(v){
    const value = new DecimalJS(v).toFixed(2)
    return Number(value);
  }
};
